




































import Vue from "vue";
import AuthService from "@/api/AuthService";

export default Vue.extend({
  props: ["dialog"],
  data() {
    return {
      editedIndex: -1,
      editedItem: {
        username: ""
      }
    };
  },
  mounted() {
    //this.editedItem = { ...this.dato };
  },
  methods: {
    dialogChange(value: boolean) {
      this.$emit("dialogChange", value);
    },
    close() {
      this.dialogChange(false);
    },
    save() {
      AuthService.resetPassword(this.editedItem)
        .then(() => {
          this.close();
          this.$emit("saved", "someValue");
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 4000,
            icon: "success",
            title: "Contraseña",
            text: "Restablecida Exitosamente"
          });
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 3000,
            icon: "error",
            title: "Contraseña",
            text: "No se pudo restablecer"
          });
        });
    }
  },
  computed: {},
  watch: {}
});
